import dayjs from 'dayjs'
import { concat } from 'lodash'
import { history } from '../../../../../store'

import { colors } from '@lmc/common/constants'

/**
@description Gets the table data for MedStockLogsTable. Returns an array of row objects.
@param {bool} showExpectedStock. Controls whether to display the Expected Stock column,
and the icons in the ActualStockCell.
@param {array} logs. The medication logs.
*/

export const getTableRows = (props) => {
  const { logs, role, showExpectedStock } = props

  return logs.map((log) => {
    const { actualStock, deleted, expectedStock, id, timeLogged } = log

    if (!log) return null

    const onSelect = () => history.push(`/logs/${id}`)

    const textStyle = { color: deleted ? colors.darkgrey : colors.black }

    return {
      key: id,
      timeLogged: {
        style: textStyle,
        value: dayjs(timeLogged).format('DD-MM-YYYY HH:mm'),
      },
      timeLoggedSortValue: dayjs(timeLogged).format('DD-MM-YYYY HH:mm'),
      log: { log, onSelect, role },
      actualStock: { actualStock, deleted, expectedStock, showExpectedStock },
      expectedStock: deleted ? null : expectedStock,
    }
  })
}

/**
@description Gets the table configuration object for MedStockLogsTable.
@param {bool} showExpectedStock. Controls whether to display the Expected Stock column
@param {string} stockQuantityType. The stock unit.
*/
export const getTableColumns = ({ showExpectedStock, stockQuantityType }) => {
  const unit = stockQuantityType ? `(${stockQuantityType})` : ''
  let columns = [
    {
      key: 'timeLogged',
      sortable: true,
      sortKey: 'timeLoggedSortValue',
      title: 'Time Logged',
      columnType: 'dateTime',
      width: 200,
    },
    {
      key: 'log',
      title: 'Logs',
      cellType: 'log',
    },
    {
      cellType: 'actualStock',
      centred: true,
      key: 'actualStock',
      title: `Stock Count ${unit}`,
    },
  ]

  const expectedStockCol = {
    cellType: 'center',
    centred: true,
    key: 'expectedStock',
    title: `Expected Stock ${unit}`,
  }

  columns = showExpectedStock ? concat(columns, expectedStockCol) : columns

  return columns
}
